<template>
  <div
    v-if="video?.url && isVisible"
    class="paragraph-remote-video"
    :class="[
      {
        container: !parentType,
        [marginClasses]: !parentType,
      },
      globalClasses,
    ]"
  >
    <MediaRemoteVideo
      v-blokkli-droppable:field_media_reference
      v-bind="video"
      :hide-overlay="options.hideOverlay"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphRemoteVideoFragment } from '#graphql-operations'

const { options, parentType } = defineBlokkli({
  bundle: 'remote_video',
  globalOptions: ['region', 'marginTop'],
  options: {
    hideOverlay: {
      type: 'checkbox',
      label: 'Hide overlay',
      default: false,
    },
  },
})

const { isVisible, marginClasses, globalClasses } =
  useMappedParagraphOptions(options)

defineProps<{
  video?: ParagraphRemoteVideoFragment['video']
}>()
</script>
